import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";

export const ConfirmacionGuardadoEliminacion = (aceptaGuardadoModal) => ({
  type: "CONFIRMACION_GUARDADO_ELIMINACION",
  aceptaGuardadoModal,
});

export const CargarDetallePrestacion = (detallePrestacion) => ({
  type: "CARGAR_DETALLE_PRESTACION_ELIMINACION",
  detallePrestacion,
});

export const OpenCargarBorrador = (aceptaGuardadoModalEliminacion) => ({
  type: "OPEN_CARGAR_BORRADOR_ELIMINAR_PRESTACION",
  aceptaGuardadoModalEliminacion,
});

export const CambiarVigenciaPrestacionEliminacion = (vigenciaPrestacionEliminacion, error) => ({
  type: "CAMBIAR_VIGENCIA_PRESTACION_ELIMINACION",
  vigenciaPrestacionEliminacion,
  error,
});

export const GuardarValorArancelEli = (valor, id) => ({
  type: "GUARDAR_VALOR_ARANCEL_ELI",
  valor,
  id,
});

export const CheckPrestacionesEli = (checked, IdPrestacion, rutArancel, centroAtencion) => ({
  type: "CHECK_PRESTACIONES_ELI",
  checked,
  IdPrestacion,
  rutArancel,
  centroAtencion,
});

export const CargarCentrosAtencionPrestacionEli = (detalleCentros) => ({
  type: "CARGAR_CENTROS_PRESTACION_ELI",
  detalleCentros,
});

export const OpenConfirmacionGuardadoEliminacion = () => (dispatch) => {
  dispatch(OpenCargarBorrador(true));
};

export const CloseConfirmacionGuardadoEliminacion = () => (dispatch) => {
  dispatch(OpenCargarBorrador(false));
};

export const LoadingArbolDetalle = (load) => ({
  type: "EDIT_ELI_PREST/LOADING_ARBOL_DETALLE",
  load,
});

export const ShowDupsMsg = dupsMsg => ({
  type: "DEL_PREST/SHOW_DUPS_MSG",
  dupsMsg
})

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const ObtenerCentrosAtencionPorPrestacionEli = (idPrestacion, CodigoPrestacion, pCodProf, pTipoAtencion, pRutArancel, pRutInstitucion, isapre, next) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdPrestacion: idPrestacion,
    CodPrestacion: CodigoPrestacion,
    RutInstitucion: pRutInstitucion,
    RutArancel: pRutArancel,
    TipoAtencion: pTipoAtencion,
    CodProf: pCodProf,
    Isapre: isapre,
    token: globalState.token,
  };
  dispatch(LoadingArbolDetalle(true));
  fetch(`${apiConfig.apiUri}/v1/centroatencion/prestacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ObtenerCentrosAtencionPorPrestacion", result);

    // Sort prests
    let rutArancelFirst = result.filter(e => e.IdPrestacion === idPrestacion)[0].RutArancel;
    let firstArancel = result.filter(e => e.RutArancel === rutArancelFirst);
    let aranceles = result.filter(e => e.RutArancel !== rutArancelFirst);
    let indexPrest = 0;
    let selectedPrest = {}

    for (const e of firstArancel) {
      if (e.IdPrestacion === idPrestacion) {
        indexPrest = firstArancel.indexOf(e);
        selectedPrest = e;
        break;
      }
    }

    firstArancel.splice(indexPrest, 1);
    firstArancel.unshift(selectedPrest);
    result = firstArancel.concat(aranceles);

    dispatch(CargarCentrosAtencionPrestacionEli(result));
    dispatch(LoadingArbolDetalle(false));
    const filtrosBusqueda = store.getState().global.filtros_CAT;
    dispatch(CheckPrestacionesEli(true, idPrestacion, filtrosBusqueda.tipoArancel, filtrosBusqueda.centroAtencion));
    //next()
  }), (error) => {
    trace.error("ObtenerCentrosAtencionPorPrestacion", error);
    // dispatch(errorObtenerDetallePrestacionEdicion(error));
  });
};

export const ObtenerDetallePrestacionEliminacion = (idPrestacion, isapre, callback) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdPrestacion: idPrestacion,
    Isapre: isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/detalle/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ObtenerDetallePrestacionEliminacion", result);
    dispatch(CargarDetallePrestacion(result));
    if (!result || !result[0]) {
      trace.error("ObtenerDetallePrestacionEliminacion", result);
    } else {
      dispatch(callback());
    }
  }), (error) => {
    trace.error("ObtenerDetallePrestacionEliminacion", error);
    // dispatch(errorObtenerDetallePrestacionEliminacion(error));
  });
};




// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/EliminarPrestacionForm/actions.js